import { render } from "./LemmasListWidget.vue?vue&type=template&id=4905afe2&scoped=true"
import script from "./LemmasListWidget.vue?vue&type=script&lang=js"
export * from "./LemmasListWidget.vue?vue&type=script&lang=js"

import "./LemmasListWidget.vue?vue&type=style&index=0&id=4905afe2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4905afe2"]])

export default __exports__